module.exports = __webpack_public_path__ + "static/media/WalletPredictionSystem.ee747e60.mp4";